<template>
  <div class="list-item">
    <span class="value" :style="{ color }">{{ label }}: {{ value }}</span>
    <span class="iconfont icon-warning" v-if="isWarning" @click="warnIconClickHandler"></span>
    <span class="unit" v-if="unit">{{ unit }}</span>
    <span class="alarm-type" v-if="alarmType">{{ alarmType }}</span>
  </div>
</template>

<script>
import { getState2Color } from '@/utils/deviceUtils/state';

export default {
  props: {
    label: String,
    value: [String, Number],
    unit: String,
    state: Number,
    faultState: Number,
    alarmType: [String, Number]
  },
  computed: {
    color() {
      return getState2Color(this.state);
    },
    isWarning() {
      return this.faultState === 1;
    }
  },
  methods: {
    warnIconClickHandler() {
      this.$emit('warn-click');
    }
  }
};
</script>

<style lang="scss">
.list-item {
  width: 100%;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  .value {
    font-size: 24px;
  }
  .unit {
    position: absolute;
    right: 10px;
    bottom: 10px;
  }
  .alarm-type {
    position: absolute;
    width: 60px;
    right: -1px;
    top: -1px;
    background: #10304f;
    border: 1px solid #00faff;
    border-radius: 20px 0 0 20px;
    text-align: center;
    color: #fff;
  }
  .icon-warning {
    font-size: 30px;
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #ffbb00;
    cursor: pointer;
  }
}
</style>
